const QUERY_STRING_OPEN_ROOM_DETAIL = "open_room_detail";
const QUERY_STRING_PLAN_ID = "plan_id";
const QUERY_STRING_ROOM_ID = "room_id";
const QUERY_STRING_NIGHT = "night";
const QUERY_STRING_COUPON_DISCOUNT = "coupon_discount";
const QUERY_STRING_POINT_DISCOUNT = "point_discount";

// start search box key
const QUERY_STRING_SEARCH_NUMBER_ADULT = "number_adult";
const QUERY_STRING_SEARCH_NUMBER_ROOM = "number_room";
const QUERY_STRING_SEARCH_TOTAL_CHILDREN = "total_children";
const QUERY_STRING_SEARCH_NUMBER_SCHOOL_STUDENT_UPPER = "upper_student_upper";
const QUERY_STRING_SEARCH_NUMBER_SCHOOL_STUDENT_LOWER = "lower_student_upper";
const QUERY_STRING_SEARCH_NUMBER_SCHOOL_INFANTS_1 = "infants_1";
const QUERY_STRING_SEARCH_NUMBER_SCHOOL_INFANTS_2 = "infants_2";
const QUERY_STRING_SEARCH_NUMBER_SCHOOL_INFANTS_3 = "infants_3";
const QUERY_STRING_SEARCH_NUMBER_SCHOOL_INFANTS_4 = "infants_4";

const QUERY_STRING_SEARCH_DATE_RANGE_1 = "start_date";
const QUERY_STRING_SEARCH_DATE_RANGE_2 = "end_date";

const QUERY_STRING_SEARCH_INPUT_KEYWORD = "kwd";
const QUERY_STRING_SEARCH_ZONE_ID = "zid";
const QUERY_STRING_SEARCH_AREA_ID = "aid";
const QUERY_STRING_SEARCH_CITY_ID = "cid";
// end search box key

// start search budget
const QUERY_STRING_SEARCH_BUDGET_FROM = "budget_from";
const QUERY_STRING_SEARCH_BUDGET_TO = "budget_to";
// end search budget

// start search theme
const QUERY_STRING_SEARCH_THEME = "hotel_theme";
// end search theme

// start search hotel type
const QUERY_STRING_SEARCH_HOTEL_TYPE = "hotel_type";
// end search hotel type

// start search hotel evalution
const QUERY_STRING_SEARCH_HOTEL_EVALUTION = "evalution";
// end search hotel evalution

// start search hotel station
const QUERY_STRING_SEARCH_HOTEL_STATION = "hotel_station";
// end search hotel station

// start search hot spot + tourist + amenity
const QUERY_STRING_SEARCH_HOTEL_HOT_SPOT = "hotel_tourist_spot";
// const QUERY_STRING_SEARCH_HOTEL_AMENITY = "hotel_amenity";
// end search hot spot

// start reservation detail
const QUERY_STRING_HOTEL_DETAIL_ID = "hotel_id";
// end reservation detail

// start resale detail
const QUERY_STRING_RESALE_DETAIL_ID = "resale_id";
// end resale detail

// start resale reservation detail
const QUERY_STRING_RESALE_RESERVATION_DETAIL_ID = "resale_servation_id";
// end resale reservation detail

// start resale filter
const QUERY_STRING_RESALE_HOTEL_NAME = "resale_hotel_name";
// end resale filter

// start room filter
const QUERY_STRING_ROOM_BED_TYPE = "bed_type";
const QUERY_STRING_ROOM_ROOM_STYLE = "room_style";
const QUERY_STRING_ROOM_SMOKING_TYPE = "smoking_type";
const QUERY_STRING_ROOM_TYPE = "room_type";
const QUERY_STRING_ROOM_AMENITY = "room_amenity";
const QUERY_STRING_ROOM_SPRING_TYPE = "spring_type";
const QUERY_STRING_ROOM_BATH_TYPE = "bath_type";
const QUERY_STRING_HOTEL_INFO_FACILITY = "room_facility";
const QUERY_STRING_SERVICE_TYPE = "service_type";
const QUERY_STRING_VIEW_TYPE = "view_type";
const QUERY_STRING_LATE_CHECKOUT = "late_checkout";
const QUERY_STRING_BENIFIT = "benifit";
const QUERY_STRING_METHOD_PAYMENT_SUPPORT = "method_payment_support";
const QUERY_STRING_HOTEL_HOT_SPRING = "hot_spring";
const QUERY_STRING_HOTEL_INFO_PET = "hotel_info_pet";
const QUERY_STRING_HOTEL_INFO_SPECIAL = "hotel_info_special";
// end room filter

// sort
const QUERY_SORT_RATING_AMENITY = "hotel_rating_amenity";
const QUERY_SORT_RATING_FACILITIES = "hotel_rating_facilities";
const QUERY_SORT_RATING_WAITING_CUSTOMERS_SERVICE =
  "hotel_rating_waiting_customers_service";
const QUERY_SORT_RATING_BATH = "hotel_rating_bath";
const QUERY_SORT_RATING_SATISFACTION = "hotel_rating_satisfaction";
const QUERY_SORT_RATING_AVG = "hotel_rating_avg";
const QUERY_SORT_RANKING = "hotel_ranking";

const QUERY_SORT_PRICE_CHEAPEST = "hotel_price_cheapest";
const QUERY_SORT_PRICE_EXPENSIVE = "hotel_price_expensive";
// end sort

const QUERY_STRING_REDIRECT_URI = "redirect_uri";

const QUERY_STRING_SEARCH_RESALE_BY_HOTEL_ID = "resale_by_hotel_id";
const QUERY_STRING_SORT = "sort";

export {
  QUERY_STRING_OPEN_ROOM_DETAIL,
  QUERY_STRING_PLAN_ID,
  QUERY_STRING_SEARCH_NUMBER_ADULT,
  QUERY_STRING_SEARCH_NUMBER_ROOM,
  QUERY_STRING_SEARCH_NUMBER_SCHOOL_STUDENT_UPPER,
  QUERY_STRING_SEARCH_NUMBER_SCHOOL_STUDENT_LOWER,
  QUERY_STRING_SEARCH_NUMBER_SCHOOL_INFANTS_1,
  QUERY_STRING_SEARCH_NUMBER_SCHOOL_INFANTS_2,
  QUERY_STRING_SEARCH_NUMBER_SCHOOL_INFANTS_3,
  QUERY_STRING_SEARCH_NUMBER_SCHOOL_INFANTS_4,
  QUERY_STRING_SEARCH_DATE_RANGE_1,
  QUERY_STRING_SEARCH_DATE_RANGE_2,
  QUERY_STRING_SEARCH_INPUT_KEYWORD,
  QUERY_STRING_SEARCH_ZONE_ID,
  QUERY_STRING_SEARCH_AREA_ID,
  QUERY_STRING_SEARCH_CITY_ID,
  QUERY_STRING_SEARCH_BUDGET_FROM,
  QUERY_STRING_SEARCH_BUDGET_TO,
  QUERY_STRING_SEARCH_THEME,
  QUERY_STRING_SEARCH_HOTEL_TYPE,
  QUERY_STRING_SEARCH_HOTEL_STATION,
  QUERY_STRING_SEARCH_HOTEL_HOT_SPOT,
  QUERY_STRING_HOTEL_DETAIL_ID,
  QUERY_STRING_RESALE_HOTEL_NAME,
  QUERY_STRING_RESALE_DETAIL_ID,
  QUERY_STRING_RESALE_RESERVATION_DETAIL_ID,
  QUERY_STRING_REDIRECT_URI,
  QUERY_STRING_SEARCH_RESALE_BY_HOTEL_ID,
  QUERY_STRING_SEARCH_TOTAL_CHILDREN,
  QUERY_STRING_ROOM_ID,
  QUERY_STRING_COUPON_DISCOUNT,
  QUERY_STRING_POINT_DISCOUNT,
  // QUERY_STRING_SEARCH_HOTEL_AMENITY,
  QUERY_STRING_ROOM_BED_TYPE,
  QUERY_STRING_ROOM_TYPE,
  QUERY_STRING_ROOM_SPRING_TYPE,
  QUERY_STRING_ROOM_BATH_TYPE,
  QUERY_STRING_SEARCH_HOTEL_EVALUTION,
  QUERY_STRING_SERVICE_TYPE,
  QUERY_STRING_VIEW_TYPE,
  QUERY_STRING_LATE_CHECKOUT,
  QUERY_STRING_BENIFIT,
  QUERY_STRING_SORT,
  QUERY_SORT_RATING_AMENITY,
  QUERY_SORT_RATING_FACILITIES,
  QUERY_SORT_RATING_WAITING_CUSTOMERS_SERVICE,
  QUERY_SORT_RATING_BATH,
  QUERY_SORT_RATING_SATISFACTION,
  QUERY_SORT_RATING_AVG,
  QUERY_SORT_PRICE_CHEAPEST,
  QUERY_SORT_PRICE_EXPENSIVE,
  QUERY_STRING_HOTEL_HOT_SPRING,
  QUERY_STRING_HOTEL_INFO_PET,
  QUERY_STRING_HOTEL_INFO_SPECIAL,
  QUERY_SORT_RANKING,
  QUERY_STRING_NIGHT,
  QUERY_STRING_ROOM_ROOM_STYLE,
  QUERY_STRING_HOTEL_INFO_FACILITY,
  QUERY_STRING_METHOD_PAYMENT_SUPPORT,
  QUERY_STRING_ROOM_SMOKING_TYPE,
  QUERY_STRING_ROOM_AMENITY,
};
